import CollectionsPage from 'src/components/pages/Content/CollectionsPage/CollectionsPage';

export default CollectionsPage;
